import { AbstractControl, ValidatorFn } from '@angular/forms';

export function normalizeRegisterAccountCode(raw: string | null | undefined): string {
  return String(raw ?? '').replace(/\D/g, '');
}

function hasInstitutionalMiolo(value: string): boolean {
  return value.substring(6, 8) === '40';
}

export function formatRegisterAccountCode(raw: string | null | undefined): string {
  const value = String(raw ?? '').trim();

  if (!value) {
    return '';
  }

  if (value.includes('.') || value.includes('-')) {
    return value;
  }

  const digits = normalizeRegisterAccountCode(value);

  if (digits.length === 10) {
    return `${digits.slice(0, 6)}.${digits.slice(6, 8)}-${digits.slice(8)}`;
  }

  if (digits.length === 8) {
    return `${digits.slice(0, 5)}.${digits.slice(5, 7)}-${digits.slice(7)}`;
  }

  return value;
}

export function isInstitutionalRegisterAccount(raw: string | null | undefined): boolean {
  const value = String(raw ?? '').trim();

  if (!value) {
    return false;
  }

  if (value.includes('.') || value.includes('-')) {
    return value.length >= 10 && hasInstitutionalMiolo(value);
  }

  const digits = normalizeRegisterAccountCode(value);
  return (digits.length === 8 || digits.length === 10) && hasInstitutionalMiolo(digits);
}

/** Conta registrador institucional B3: miolo 40 (formato 00000.40-0). */
export function ValidateInstitutionalRegisterAccount(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = String(control.value ?? '').trim();

    if (!value) {
      return null;
    }

    if (value.includes('.') || value.includes('-')) {
      if (value.length < 10) {
        return { invalidLength: true };
      }

      if (!hasInstitutionalMiolo(value)) {
        return { invalidChar: true };
      }

      return null;
    }

    const digits = normalizeRegisterAccountCode(value);

    if (digits.length !== 8 && digits.length !== 10) {
      return { invalidLength: true };
    }

    if (!hasInstitutionalMiolo(digits)) {
      return { invalidChar: true };
    }

    return null;
  };
}
